import styled from 'styled-components';
import { media } from '@prima-afp/prima-ui-elements/dist/utils/media/styledConfig';
import HeroImage from '../../../../../../assets/images/hero.jpg';
import { Text } from '../../../../../shared/components';

export const HeroGrid = styled.div`
  height: 100vh;
  grid-area: hero;
  top: ${props => props.scrollPosition}px;
  position: relative;
  background-image: url(${HeroImage});
  background-size: cover;
  background-position: center top;
  ${media.sm`
    height: 300px;
    top: 0;
  `}
  ${media.xs`
    height: 300px;
    top: 0;
  `}
`;

export const HeroOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(0deg, rgba(255, 79, 0, 0.72) 12.17%, rgba(255, 79, 0, 0.423) 44.9%, rgba(255, 215, 169, 0) 75.65%);
  ${media.sm`
    background: linear-gradient(181.76deg, rgba(255, 79, 0, 0.702) 1.48%, rgba(0, 0, 0, 0.315) 106.07%);
    transform: rotate(-180deg);
  `}
  ${media.xs`
    background: linear-gradient(181.76deg, rgba(255, 79, 0, 0.702) 1.48%, rgba(0, 0, 0, 0.315) 106.07%);
    transform: rotate(-180deg);
  `}
`;

export const HeroContent = styled.div`
  position: absolute;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 20% 15%;

  ${media.sm`
    padding: 3rem 5rem;
  `}
  ${media.xs`
    padding: 2rem 3rem;
  `}
`;

export const HeroIcon = styled.img`
  width: 56px;
  margin-bottom: 20px;
  ${media.sm`
    width: 46px;
  `}
  ${media.xs`
    width: 46px;
  `}
`;

export const HeroText = styled(Text)`
  font-family: 'FS Emeric';
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #FFFFFF;
  ${media.xs`
    font-size: 17px;
    line-height: 20px;
  `}
`;